// Core
import { Map } from 'immutable';
import { handleActions, combineActions } from 'redux-actions';

// Instruments
import { hotelsActions } from './actions';

const initalState = Map();

export const hotelsReducer = handleActions(
    {
        [combineActions(
            hotelsActions.addHotel,
            hotelsActions.getHotelSuccess
        )]: (state, { payload: hotel }) => {
            const { id } = hotel;

            return state.set(String(id), hotel);
        },
        [hotelsActions.addHotels]: (state, { payload: hotels }) => {
            return Map(hotels).mergeDeep(state);
        },
    },
    initalState
);
